<main class="container">
  <left-menu />
  <section id="column2">
    <div class="row">
      <div class="col col-12">
        <h1>Dent-Gouge Combinations</h1>
        <mat-horizontal-stepper [linear]="isLinear" #stepper labelPosition="bottom">
          <mat-step [stepControl]="firstFormGroup">
            <ng-template matStepLabel>Applicability and Limitations</ng-template>
            <form [formGroup]="firstFormGroup">
              <!-- <div class="result">
                <p [innerHTML]="applicability"></p>
              </div>
              <hr /> -->
              <!-- new implementation by shameer-->
              <div class="result">
                <ol type="1">
                  <li><tr><mat-label>The original design criteria were in accordance with a recognized code or standard.</mat-label></tr></li>
                  <li><tr><mat-label>The component is not operating in the creep range. See the Help Menu for temperature limit used to define the creep range.</mat-label></tr></li>
                  <li><tr><mat-label>The material is considered to have sufficient material toughness and the component is not subject to embrittlement during operation due to temperature and/or process environment. Note that cold work may be produced by the deformation. This cold worked area may be more susceptible to some forms of mechanical and environmental cracking.</mat-label></tr></li>
                  <li><tr><mat-label>The component is not in cyclic service (i.e., less than 150 cycles in past and future planned operation or satisfying the cyclic service screening criteria).</mat-label></tr></li>
                  <li><tr><mat-label>The component is a carbon steel cylindrical shell subject only to internal pressure (i.e supplemental loads are assumed to be negligible).</mat-label></tr>
                  <li><tr><mat-label>The component material is carbon steel with a specified minimum yield strength, SMYS, less than or equal to 70 ksi (482 MPa).</mat-label></tr>
                  <li><tr><mat-label>The dent-gouge combination is an inward deviation of the shell cross section.</mat-label></tr>
                  <li><tr><mat-label>The dent-gouge combination is isolated from other dents and dent-gouge combinations.</mat-label></tr>
                  <br />
                  <tr><mat-label><b>Select an option for Type A Component screening :</b></mat-label>
                    <button class="btn btn-primary no-arrow float-right" [disabled] = "isreevalu" (click)="typeareevaluate()" >ReEval&nbsp;<span class="icon-chevron-right"></span></button>
                  </tr> 
                  <ol type="a">
                    <li><tr><mat-label>Pressure vessels</mat-label></tr></li>
                    <!-- </div> -->
                      <tr>
                        <mat-radio-group [style.fontSize.px]="6" [style.padding]="3" name ="TypeA" formControlName="radio"  class="small-radio-button"  (change)="onRadioChange($event)">
                        <td><mat-radio-button matTooltip="{{ tooltipText1 }}" matTooltipClass="my-custom-tooltip mdc-tooltip__surface multiline-tooltip"  name="VS" value ="1" style=" height: 10px; width: 10px;" color = "primary" class="smallRadio">Vertical Vessel</mat-radio-button></td>
                        <td><mat-radio-button matTooltip="{{ tooltipText2 }}" matTooltipClass="my-custom-tooltip mdc-tooltip__surface multiline-tooltip" name="VS" value ="2" color = "primary">Horizontal Vessel</mat-radio-button></td>
                        </mat-radio-group>
                      </tr>
                   <!-- <ol> -->
                    <!-- <li><tr><mat-radio-group  name ="TypeA"  formControlName="radio" (change)="onRadioChange($event)"><td><mat-radio-button  name="VS" color = "primary" [value] ="5"></mat-radio-button></td></mat-radio-group><mat-label>Spherical components and formed heads (elliptical, F&D Head and torispherical)</mat-label></tr></li> -->
                    <!-- <li><tr><mat-radio-group  name ="TypeA"  formControlName="radio" (change)="onRadioChange($event)"><td><mat-radio-button  name="VS" [value] ="6"></mat-radio-button></td></mat-radio-group><mat-label>Spherical, elliptical and torispherical formed heads </mat-label></tr></li> -->
                    <li><tr><mat-label>Straight sections of piping systems and elbows or pipe bends that do not have structural attachments satisfying the size and temperature criteria </mat-label></tr></li>
                      <tr>
                      <mat-radio-group  name ="TypeA"  formControlName="radio"   (change)="onRadioChange($event)"  class="size:small-button">
                        <td><mat-radio-button  matTooltip="{{ tooltipText3 }}" matTooltipClass="my-custom-tooltip mdc-tooltip__surface multiline-tooltip" class="size:small" color = "primary" name="VS" value ="3">Carbon and Low Alloy Steel</mat-radio-button></td>
                        <td><mat-radio-button matTooltip="{{ tooltipText4 }}" matTooltipClass="my-custom-tooltip mdc-tooltip__surface multiline-tooltip" color = "primary" name="VS" value ="4">High Alloy and Nonferrous Steel</mat-radio-button></td>
                      </mat-radio-group>
                      </tr>
                    <li><tr><mat-radio-group name ="TypeA"  formControlName="radio"  (change)="onRadioChange($event)"><td><mat-radio-button color = "primary"  name="VS" value ="7" [disabled] ="isCylAtmradio"></mat-radio-button></td></mat-radio-group><mat-label [disabled]="isCylAtmradio" style="color: lightgrey;">Cylindrical atmospheric storage tank shell courses </mat-label></tr></li>
                  </ol>
                </li>
              </ol>
              <!-- </div> -->
            </div>
            <hr />
            <div>
                <mat-checkbox
                  required
                  color = "primary"
                  formControlName="applicabilityCheckbox"
                  [ngClass]="{
                    'text-light-red':
                      firstFormGroup.controls['applicabilityCheckbox']
                        .invalid &&
                      (firstFormGroup.controls['applicabilityCheckbox'].dirty ||
                        firstFormGroup.controls['applicabilityCheckbox']
                          .touched)
                  }"
                >
                  <div class="float-left no-margin">
                    All the conditions listed above are met.
                  </div>
                  <div
                    class="text-light-red float-right no-margin"
                    *ngIf="
                      firstFormGroup.controls['applicabilityCheckbox']
                        .invalid &&
                      (firstFormGroup.controls['applicabilityCheckbox'].dirty ||
                        firstFormGroup.controls['applicabilityCheckbox']
                          .touched)
                    "
                  >
                    (Required)
                  </div>
                </mat-checkbox>
                <!-- <button
                  (click)="goToComponent()"
                  class="btn btn-primary no-arrow float-right arrow"
                >
                  Next&nbsp;
                  <span class="icon-chevron-right"></span>
                </button> -->
              </div>
              <tr></tr>
              <div>
                  
                <mat-checkbox
                  required
                  color = "primary"
                  formControlName="typeACheckbox"
                  id = "CheckboxTypeA" [disabled]="isCheckboxDisabled"
                  [ngClass]="{
                    'text-light-red':
                      firstFormGroup.controls['typeACheckbox']
                        .invalid &&
                      (firstFormGroup.controls['typeACheckbox'].dirty ||
                        firstFormGroup.controls['typeACheckbox']
                          .touched)
                  }"
                >
                  <div class="float-left no-margin">
                    Proceed with the assessment excluding Type A Component screening results.
                  </div>
                  <div
                    class="text-light-red float-right no-margin"
                    *ngIf="
                      firstFormGroup.controls['typeACheckbox']
                        .invalid &&
                      (firstFormGroup.controls['typeACheckbox'].dirty ||
                        firstFormGroup.controls['typeACheckbox']
                          .touched)
                    "
                  >
                    (Required)
                  </div>
                </mat-checkbox>
                <button
                (click)="goToComponent()"
                class="btn btn-primary no-arrow float-right arrow"
                 >
                Next&nbsp;
                <span class="icon-chevron-right"></span>
              </button>
            </div>
            </form>
          </mat-step>
          <mat-step [stepControl]="secondFormGroup">
            <ng-template matStepLabel>Component MAWP</ng-template>
            <mawp
              #mawpComponent
              (formDataChange)="handleFormData($event)"
              (summaryCalculated)="handleSummaryData($event)"
              (nextStep)="goNextStep()"
            >
            </mawp>
            <br />
            <div>
              <button
                class="btn btn-primary no-arrow float-left"
                (click)="goPreviousStep()"
              >
                <span class="icon-chevron-left"></span>
                &nbsp;Back
              </button>
              <button
                class="btn btn-primary no-arrow float-right"
                (click)="mawpComponent.calculateSummary()"
              >
                Next&nbsp;
                <span class="icon-chevron-right"></span>
              </button>
            </div>
          </mat-step>

          <mat-step>
            <ng-template matStepLabel>Inspection Data</ng-template>
            <inspection-data
              [MAWP_result]="summary"
              [inspectionDataCalc]="inspectionDataCalculate"
              (inspectionDataResult)="handleInspectionData($event)"
              (nextStep)="goNextStep()"
            ></inspection-data>
            <div>
              <button
                class="btn btn-primary no-arrow float-left"
                matStepperPrevious
              >
                <span class="icon-chevron-left"></span>
                &nbsp;Back
              </button>
              <button
                (click)="calculateResult()"
                class="btn btn-primary no-arrow float-right arrow"
              >
                Next&nbsp;
                <span class="icon-chevron-right"></span>
              </button>
            </div>
          </mat-step>

          <mat-step>
            <ng-template matStepLabel>Results</ng-template>
            <fieldset class="border rounded-3 p-3">
              <legend class="subtitle-4 float-none w-auto px-3">
                Dent-Gouge Assessment Results
              </legend>
              <div class="container">
                <div class="result">
                  <p [innerHTML]="inspectionDataResult"></p>
                </div>
              </div>
            </fieldset>
            <br />
            <dent-chart [updateChartData]="updateChart"></dent-chart>
            <br />
            <div>
              <button
                class="btn btn-primary no-arrow float-left"
                matStepperPrevious
              >
                <span class="icon-chevron-left"></span>
                &nbsp;Back
              </button>
            </div>
            <div>
              <print-report></print-report>
            </div>
          </mat-step>
        </mat-horizontal-stepper>
      </div>
    </div>
  </section>
</main>
